import { Button, Col, Row, Space, Tabs } from 'antd';
import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import Language from 'components/Language';

const TranslationTabs = ({ primary, translations, onAddTranslation, primaryContent, translationsContent, singleColumn, columnSpan = 12 }) => {
  const items = [{
    key: primary.id,
    label: (
      <Space>
        <span>Primary language</span>
        <Language {...primary} />
      </Space>
    ),
    children: primaryContent,
  }];

  const translationItems = translations.map((t, i) => ({
    key: t.id,
    label: <Language {...t} />,
    children: translationsContent?.[i],
  }));

  if (singleColumn) {
    items.push(...translationItems);
  }

  return (
    <Row gutter={32}>
      <Col span={!singleColumn && translations?.length ? columnSpan : 24}>
        <Tabs
          tabBarExtraContent={onAddTranslation && { right: <Button icon={<PlusOutlined />} onClick={onAddTranslation}>Add language</Button> }}
          type="card"
          items={items}
        />
      </Col>
      {!singleColumn && translations?.length > 0 && (
      <Col span={columnSpan}>
        <Tabs type="card" items={translationItems} />
      </Col>
      )}
    </Row>
  );
};

export default TranslationTabs;
